import { SectionTitle, StepShell } from "./Section";
import { ArrowLeft } from "lucide-react";

const Field = ({ label, children }) => (
  <div className="space-y-1.5">
    <label className="block text-[15px] font-medium text-[#4C1D95]">{label}</label>
    {children}
  </div>
);

const inputCls =
  "w-full rounded-xl border border-[#D4AF37]/35 bg-white/90 px-4 py-3 text-[16px] text-[#222] placeholder-[#9a9070] outline-none focus:border-[#D4AF37] focus:ring-2 focus:ring-[#D4AF37]/30 transition";

export const DataForm = ({ data, onChange, onBack, onSubmit }) => {
  const set = (k) => (e) => onChange({ ...data, [k]: e.target.value });

  return (
    <StepShell>
      <button
        data-testid="form-back-btn"
        onClick={onBack}
        className="flex items-center gap-2 text-[15px] text-[#6b4f12] hover:text-[#b8860b] mb-4 transition-colors"
      >
        <ArrowLeft size={18} /> Zurück
      </button>

      <SectionTitle kicker="Schritt 4">Deine Daten</SectionTitle>
      <p className="text-center max-w-2xl mx-auto -mt-4 mb-8 text-[15px] leading-relaxed text-[#333]">
        Bitte gib deine Daten ein, damit die Analyse präzise auf dich abgestimmt
        werden kann.
      </p>

      <div className="space-y-6 bg-white/80 backdrop-blur-md p-6 sm:p-8 rounded-3xl border border-[#4C1D95]/10 shadow-xl max-w-2xl mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
          <Field label="Name">
            <input data-testid="input-name" className={inputCls} value={data.name} onChange={set("name")} placeholder="Dein Name" />
          </Field>
          <Field label="Geburtsort">
            <input data-testid="input-birthplace" className={inputCls} value={data.birthplace} onChange={set("birthplace")} placeholder="z. B. München" />
          </Field>
          <Field label="Geburtsdatum">
            <input data-testid="input-birthdate" type="date" className={inputCls} value={data.birthdate} onChange={set("birthdate")} />
          </Field>
          <Field label="Uhrzeit">
            <input data-testid="input-birthtime" type="time" className={inputCls} value={data.birthtime} onChange={set("birthtime")} />
          </Field>
        </div>
        <Field label="Aktuelle berufliche Situation">
          <textarea data-testid="input-situation" rows={3} className={inputCls} value={data.situation} onChange={set("situation")} placeholder="Beschreibe kurz deine aktuelle Lage..." />
        </Field>
        <Field label="Frage / Anliegen">
          <textarea data-testid="input-question" rows={3} className={inputCls} value={data.question} onChange={set("question")} placeholder="Was möchtest du wissen?" />
        </Field>

        <button
          data-testid="form-submit-btn"
          onClick={onSubmit}
          className="serif text-lg w-full py-3.5 rounded-full bg-gradient-to-r from-[#F0C548] to-[#B8860B] text-white glow-soft hover:glow-strong transition-all duration-300"
        >
          Karten ziehen
        </button>
      </div>
    </StepShell>
  );
};
